// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-entity-page',
    // #endregion
    // #region Properties
    data: () => ({
        _self: null,
        _modals: [],
    }),
    // #endregion
    // #region Computed
    computed: {
        window() {
            return this._self;
        }
    },
    // #region Constructor
    created() {
        this._self = this.$route.segements.find(e => e.navigation.isActive && !e.navigation.isModal);
        this._modals = this.$route.segements.filter(e => e.navigation.isActive && e.navigation.isModal);
    },
    // #endregion
    // #region Watch
    watch: {
        "$route"(value) {
            if (this.$route?.segements) {
                this._self = this.$route.segements.find(e => e.navigation.isActive && !e.navigation.isModal);
                this._modals = this.$route.segements.filter(e => e.navigation.isActive && e.navigation.isModal);
            }
        },
    },
    // #endregion
});
// #endregion
